// Description: This endpoint is used to check if the QR code is in the database.
// Updated: 21/08/2025
// Author: Vitor de Jesus

import axios from 'axios';

export async function ChannelCheckQRCode(code) {
    try {
        
        const token = localStorage.getItem('jwt_token');
        const clientId = localStorage.getItem('idToken');

        if (!token) throw new Error('Token de autenticação não encontrado');

        if (!clientId) throw new Error('ID do cliente não encontrado');

        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_AWS_URL}/channels/whatsapp/web/qrcode`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    'Client_ID': `${clientId}` 
                },
                params: {
                    code: code
                }
            }
            
        );
        
        const responseData = response.data;

        return responseData;
    } catch (error) {
        console.error('Erro ao buscar dados da API:', error);
        throw new Error('Erro ao buscar dados da API');
    }
}